module.exports = __webpack_public_path__ + "img/arrow.1b6eb67e.jpg";